export default __webpack_public_path__ + "static/media/arrow-down-solid.245d801f.svg";